import { render, staticRenderFns } from "./Nursing.vue?vue&type=template&id=6fc05d32&scoped=true&"
import script from "./Nursing.vue?vue&type=script&lang=js&"
export * from "./Nursing.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6fc05d32",
  null
  
)

export default component.exports